import React, { useMemo, useState } from "react";
import PropTypes from "prop-types";
import GridSearchTemplate from '../../pages/GridSearchTemplate';
import { Button, Form, Icon, Label, Modal } from "semantic-ui-react";
import HotelsDropDown from "../../components/shared/HotelsDropDown";
import WingDropDown from "../../components/shared/WingDropDown";
import CustomerDropDown from "../../components/shared/CustomerDropDown";
import { useTextResources } from "../../language";
import NumericInput from '../../components/shared/NumericInput';
import { DatePicker, TimePicker } from "../../components/shared/DatePicker";
import ReservationStatusesDropDown from "../../components/shared/ReservationStatusesDropDown";
import { Reports } from "../../api/services/next";
//import { formatValueAsCurrency } from '../../components/shared/utils'
import moment from "moment";
import { formatValueAsCurrency } from "../../components/shared/utils";
import { DualAxes } from "@ant-design/charts";
import ReactJson from '@microlink/react-json-view';

export const Report = ({ report, editable, onDeleteFilter, onEditFilter }) => {
    const text = useTextResources()
    
    
    const controls = {
        "Hotel": HotelsDropDown,
        "Wing": WingDropDown,
        "Customer": CustomerDropDown,
        "ReservationStatus": ReservationStatusesDropDown,
        "Number": NumericInput,
        "Time": TimePicker,
        "Date": DatePicker
    }
    const charts = {
        "DualAxes": DualAxes
    }
    
    const FilterField = ({definition, ...rest})=>{
        const [isOver, setIsOver] = useState(false)
        const ComponentTag = controls[definition.entityType || definition.fieldType];
        const FieldIcon = ({name, position, onClick}) =>{
            if (editable && isOver) {
                return <Icon style={{position: "absolute", zIndex: 999, top: -10, right: position}} size="small" inverted circular name={name} link onClick={()=>onClick?.(definition)}/>
            } else {
                return null
            }
        }
        return <Form.Field {...definition.fieldOptions} onMouseEnter={()=>setIsOver(true)} onMouseLeave={()=>setIsOver(false)}>
        <label>{text(definition.label || definition.name)}</label>
        <div className="field" style={{ position: "relative" }}>
            {ComponentTag ? 
            <ComponentTag {...definition.fieldOptions} {...rest}/> :
            <Label>Undefined componenet: {definition.entityType || definition.fieldType}</Label>
            }
            <FieldIcon position={-10} name="setting" onClick={onEditFilter}/>
            <FieldIcon position={12} name="trash" onClick={onDeleteFilter}/>
        </div>
        </Form.Field>

       
    }
    

    const formatter = ({ value }) => {
        return value || "";
    };
    //formatValueAsCurrency(1,1)
    const createFormatter = field=>{
        switch(field.FieldType)
        {
            case "Date":
                return ({value})=>value?moment(value).format(field.Format):""
            case "Currency":
                return ({value, row})=>{
                    var currencyId = row[field.Format]
                    return value?formatValueAsCurrency(value, currencyId):""
                }
        }
        return formatter;
    }
    const gridOptions = useMemo(() => {
        if (report?.Definition) {
            const fields = report.Definition.filters
                ?.map(x => <FilterField key={x.name} definition={x}/>)
            const columns = report.Definition.fields
            ?.filter(x=>x.display !== false)
            ?.map(x=>{
                return {
                    name: x.name, 
                    title: x.title || x.name,
                    formatter: x.format?createFormatter(x):formatter
                }
            })

            const buildChart = data=>{
                if (report.Definition.Chart) {
                    const chart = report.Definition.chart;
                    const ChartTag = charts[chart.type]
                    if (chart.transform) {
                        data = chart.transform.map(x=>{
                            var f = new Function(x.arguments, x.body);
                            return data ? f(data): []
                        })
                    }
                    return <ChartTag {...chart} data={data}></ChartTag>
                }
            }

            const ReportDefinitionPopup = () => {
                return <Modal
                    trigger={<Button floated="right" size="tiny">Report Definition</Button>}
                    header="Report Definition"
                    content={
                        <Modal.Content>
                            <ReactJson src={report.Definition} style={{height: 400, overflow: "auto" }}></ReactJson>
                        </Modal.Content>
                    }
                />
            }

            return {
                search: {
                    title: <div>
                        {report.Definition.title}
                        {editable && <ReportDefinitionPopup/>}
                    </div>,
                    fields: fields,
                    api: Reports.RunReport,
                    method: "POST",
                    buildSpec: state=>{
                        const spec = {
                            ...report,
                            Definition: JSON.stringify({ 
                                ...report.Definition,
                                filters: report.Definition.filters.map(x=>({
                                    ...x,
                                    value: state[x.name]
                                }))
                            })
                        }
                        
                        return spec
                    }
                },
                grid: {
                    columns: columns || [],
                    showFilter: true,
                    filtering: true,
                    grouping: true,
                    customOptions: {
                        sort: true,
                        group: {

                        },
                        order: {
                            
                        }
                    },
                    paging: true,
                    noVirtualTable: true
                },
                chart: report.Definition.chart && buildChart
            }
        }
        else {
            return {
                search: {
                    title: "No report selected"
                },
                grid: {
                    columns: [],
                    noVirtualTable: true
                }
            }
        }
    }, [report])
    return <GridSearchTemplate options={gridOptions}></GridSearchTemplate>
}

Report.propTypes = {
    report: PropTypes.object,
    editable: PropTypes.bool,
    onEditFilter: PropTypes.func,
    onDeleteFilter: PropTypes.func
}
